<template>
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="63.07px"
		 height="72.08px" viewBox="0 0 63.07 72.08" style="enable-background:new 0 0 63.07 72.08;" xml:space="preserve">
		<g>
	<path class="st0" d="M63.07,18.02L45.05,0H13.52c-2.48,0-4.51,2.03-4.51,4.51v63.07c0,2.48,2.03,4.51,4.51,4.51h45.05
		c2.48,0,4.51-2.03,4.51-4.51"/>
			<path class="st1" d="M63.07,18.02L45.05,0v13.52c0,2.48,2.03,4.51,4.51,4.51H63.07"/>
			<polyline class="st2" points="63.07,31.54 49.56,18.02 63.07,18.02 	"/>
			<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0" y1="47.3045" x2="54.0623" y2="47.3045">
		<stop  offset="0.6457" style="stop-color:#E95C27"/>
				<stop  offset="0.7566" style="stop-color:#EA642E"/>
				<stop  offset="0.9268" style="stop-color:#EE7942"/>
				<stop  offset="1" style="stop-color:#F0854C"/>
	</linearGradient>
			<path class="st3" d="M54.06,58.57c0,1.24-1.01,2.25-2.25,2.25H2.25C1.01,60.82,0,59.81,0,58.57V36.04c0-1.24,1.01-2.25,2.25-2.25
		h49.56c1.24,0,2.25,1.01,2.25,2.25V58.57z"/>
			<g>
		<path class="st4" d="M9.82,42.68c0-0.59,0.47-1.24,1.22-1.24h4.16c2.34,0,4.45,1.57,4.45,4.57c0,2.85-2.11,4.43-4.45,4.43H12.2
			v2.38c0,0.79-0.5,1.24-1.15,1.24c-0.59,0-1.22-0.45-1.22-1.24V42.68z M12.2,43.7v4.49h3.01c1.21,0,2.16-1.07,2.16-2.18
			c0-1.26-0.96-2.3-2.16-2.3H12.2z"/>
				<path class="st4" d="M23.18,54.06c-0.59,0-1.24-0.32-1.24-1.12V42.72c0-0.65,0.65-1.12,1.24-1.12h4.12
			c8.23,0,8.05,12.46,0.16,12.46H23.18z M24.32,43.8v8.07h2.99c4.86,0,5.08-8.07,0-8.07L24.32,43.8L24.32,43.8z"/>
				<path class="st4" d="M38.28,43.94v2.86h4.59c0.65,0,1.3,0.65,1.3,1.28c0,0.59-0.65,1.08-1.3,1.08h-4.59v3.78
			c0,0.63-0.45,1.12-1.08,1.12c-0.79,0-1.28-0.48-1.28-1.12V42.71c0-0.65,0.49-1.12,1.28-1.12h6.32c0.79,0,1.26,0.47,1.26,1.12
			c0,0.58-0.47,1.23-1.26,1.23L38.28,43.94L38.28,43.94z"/>
	</g>
			<path class="st5" d="M51.81,60.82H9.01v2.25h42.8c1.24,0,2.25-1.01,2.25-2.25v-2.25C54.06,59.81,53.05,60.82,51.81,60.82z"/>
</g>
</svg>

</template>

<script>
    export default {
        name: "IconPdf"
    }
</script>

<style scoped>
	.st0{fill:#E2E5E7;}
	.st1{fill:#B0B7BD;}
	.st2{fill:#CAD1D8;}
	.st3{fill:url(#SVGID_1_);}
	.st4{fill:#FFFFFF;}
	.st5{fill:none;}
	.st6{fill:url(#SVGID_2_);}
</style>